<template>
  <div>
    <section class="banner-logado parallax-window" data-parallax="scroll" :data-image-src="bannerHome">
      <div class="container text-center">
        <h1>{{ mensagemBoasVindas }}</h1>
        <form>
          <div class="search-home d-flex justify-content-center">
            <input type="text" class="search-term" placeholder="Busque por conteúdos, cursos e muito mais!" v-model="termoPesquisa">
            <button type="submit" class="searchButton" @click="buscaGeralPlataforma">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </form>
      </div>
    </section>
    <section class="destaques-logado">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center mt-md-4">
              <i class="fas fa-rocket"></i>
              <div>
                <p id="qtd-cursos">
                  <animated-number :value="qtdeTopicosConcluidos" :formatValue="formatIntegerNumber" :duration="800"/>
                </p>
                <p>Tópicos concluídos</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center mt-md-4">
              <i class="fas fa-video"></i>
              <div>
                <p id="qtd-videos">
                  <animated-number :value="qtdeVideosAssistidos" :formatValue="formatIntegerNumber" :duration="800"/>
                </p>
                <p>Vídeos assistidos</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex align-items-center mt-md-4">
              <i class="fas fa-check-circle"></i>
              <div>
                <p id="qtd-questoes">
                  <animated-number :value="qtdeQuestoesRespondidas" :formatValue="formatIntegerNumber" :duration="800"/>
                </p>
                <p>Questões respondidas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import 'jquery-parallax.js'
import AnimatedNumber from 'animated-number-vue'

import ResumoHomeAPI from '@/api/resumo-home-api'
import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'HomeApp',
  components: {
    AnimatedNumber
  },
  data () {
    return {
      termoPesquisa: '',
      qtdeTopicosConcluidos: 0,
      qtdeVideosAssistidos: 0,
      qtdeQuestoesRespondidas: 0,
      imagem: ''
    }
  },

  created () {
    if (this.$configEmpresa.bannerParallax && this.$configEmpresa.bannerParallax.home) {
      this.bannerHome = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/${this.$configEmpresa.bannerParallax.home}`
    } else {
      this.bannerHome = require('@/assets/img/bannerhomewl.jpg')
    }
    setTimeout(function () {
      $('.parallax-window').parallax({ imageSrc: this.bannerHome })
    }, 100)
  },

  beforeDestroy () {
    $('.parallax-mirror').remove()
  },

  mounted () {
    this.termoPesquisa = this.$route.query.q
    ResumoHomeAPI.obterEstatisticasHome().then(data => {
      this.qtdeTopicosConcluidos = data.topicos_concluidos
      this.qtdeVideosAssistidos = data.videos_assistidos
      this.qtdeQuestoesRespondidas = data.questoes_respondidas
    }).then(() => {
      $(window).trigger('resize.px.parallax')
    })
  },

  computed: {
    mensagemBoasVindas: function () {
      let mensagem = 'Seja bem-vindo(a)'

      if (this.$configEmpresa && this.$configEmpresa.boasvindas && this.$configEmpresa.boasvindas.mensagem) {
        mensagem = this.$configEmpresa.boasvindas.mensagem
        if (this.$configEmpresa.boasvindas.exibirNome) {
          const nomeCompleto = LoginUtils.getUsuario().name.split(' ')
          if (nomeCompleto.length >= 1) mensagem += ' ' + nomeCompleto[0]
        }
      }

      return mensagem
    }
  },

  methods: {
    formatIntegerNumber (value) {
      return Number(value).toFixed(0)
    },

    buscaGeralPlataforma: function (event) {
      event.preventDefault()

      this.$store.dispatch('buscaGeralPlataforma', this.termoPesquisa)
      this.$router.push(`/busca?q=${this.termoPesquisa}`)
    }
  }
}
</script>

<style>

</style>
